import React from 'react';
import { Heading } from '@trainline/depot-web';
import { ValidatedJourney } from 'packages/hooks/api/useFetchJourneys';
import { FormattedMessage } from 'react-intl';
import { css } from 'aphrodite/no-important';

import { FareWrapper } from '../FareWrapper/FareWrapper';
import { JourneyList } from '../JourneyList/JourneyList';
import messages from '../../messages';

import styles from './styles';

interface Props {
  validatedJourneys?: ValidatedJourney;
  isCurrent: boolean;
}

export const FareSummary = ({ validatedJourneys, isCurrent = false }: Props) => (
  <>
    <Heading>
      <FormattedMessage {...(isCurrent ? messages.validatedJourneys : messages.fareSummary)} />
    </Heading>

    {!validatedJourneys?.products?.length && (
      <p className={css(styles.subduedText)}>
        <FormattedMessage
          {...(isCurrent ? messages.noValidatedJourneys : messages.noFareSummaries)}
        />
      </p>
    )}

    {validatedJourneys?.products?.map((product) => {
      const { journeys, ...props } = product;
      return (
        <FareWrapper key={props.uri || props.type} {...props}>
          <JourneyList journeys={journeys} />
        </FareWrapper>
      );
    })}
  </>
);
